import { render, staticRenderFns } from "./PurchNavBar.vue?vue&type=template&id=72422f40"
import script from "./PurchNavBar.vue?vue&type=script&lang=js"
export * from "./PurchNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports